import * as React from 'react';

import { IconLockClosed } from '@lightspeed/flame/Icon/LockClosed';
import { Text } from '@lightspeed/flame/Text';

import { AnalyticsPromoModalLink } from 'root/apps/Analytics/AnalyticsPromoModalLink';
import { usePromoClicked } from 'root/apps/helpers/analyticsPromoUtils';

import { OverlayDiv, PromoTable } from './AnalyticsLoader.style';

type Props = {
  rowCount: number;
};

export const PromoCell: React.FC<Props> = ({ rowCount }) => {
  const { hasBeenClicked, hidePromo } = usePromoClicked();

  const hidePaywall = async (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    await hidePromo(false);
    window.location.reload();
  };

  return (
    <div style={{ position: 'relative', height: '100%' }}>
      <div style={{ minHeight: '150px' }} />
      <PromoTable>
        <tbody>
          {Array.from({ length: rowCount }, (_, i) => (
            <tr key={`analytics_promo_row_${i}`}>
              <td style={{ textAlign: 'right' }}>{Math.floor(Math.random() * 10)}</td>
            </tr>
          ))}
        </tbody>
      </PromoTable>
      <OverlayDiv>
        <div>
          <IconLockClosed />
          {hasBeenClicked ? (
            <Text style={{ maxWidth: '200px' }}>An account manager will reach out to you soon</Text>
          ) : (
            <>
              <Text mt={2}>
                <AnalyticsPromoModalLink>Learn more</AnalyticsPromoModalLink>
              </Text>
              <Text>about this feature</Text>
              <Text mt={2}>
                <a
                  data-test="hide-paywall"
                  href="#"
                  style={{ fontWeight: 'normal', textDecoration: 'underline', color: '#000' }}
                  onClick={hidePaywall}
                >
                  I&rsquo;m not interested
                </a>
              </Text>
            </>
          )}
        </div>
      </OverlayDiv>
    </div>
  );
};
